import { apiGet, apiPost } from '@/utils/api';
import getPath from '@/utils/getPath';
import { handleApiError } from '@/utils/errorHandler';

export const workGapStatsApi = {
  /**
   * @apiRoute GET '/stats/workgap/insights/last-updated'
   */
  async getLastUpdated() {
    try {
      return await apiGet(getPath('stats/workgap/insights/last-updated'));
    } catch (err) {
      await handleApiError(
        err,
        'getLastUpdated',
        true,
        'Error fetching last updated'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/workgap/details'
   */
  async getDetails(payload) {
    try {
      return await apiPost(getPath('stats/workgap/details'), payload);
    } catch (err) {
      await handleApiError(err, 'getDetails', true, 'Error fetching details');
    }
  },

  /**
   * @apiRoute POST 'stats/workgap/insights/<type>'
   */
  async getAverageTotalInsights(payload) {
    try {
      return await apiPost(
        getPath('stats/workgap/insights/average-total'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getAverageTotalInsights',
        true,
        'Error fetching insights'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/workgap/insights/<type>'
   */
  async getMonthlyInsights(payload) {
    try {
      return await apiPost(getPath('stats/workgap/insights/monthly'), payload);
    } catch (err) {
      await handleApiError(
        err,
        'getMonthlyInsights',
        true,
        'Error fetching insights'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/workgap/insights/<type>'
   */
  async getHighOccurrenceDays(payload) {
    try {
      return await apiPost(
        getPath('stats/workgap/insights/high-occurrence-days'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getHighOccurrenceDays',
        true,
        'Error fetching insights'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/workgap/insights/<type>'
   */
  async getMostOccurrences(payload) {
    try {
      return await apiPost(
        getPath('stats/workgap/insights/most-occurrences'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getMostOccurrences',
        true,
        'Error fetching insights'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/workgap/breakout/<type>'
   */
  async getBreakoutChart(payload) {
    try {
      return await apiPost(getPath('stats/workgap/breakout/chart'), payload);
    } catch (err) {
      await handleApiError(
        err,
        'getBreakoutChart',
        true,
        'Error fetching breakout chart'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/workgap/breakout/<type>'
   */
  async getBreakoutTable(payload) {
    try {
      return await apiPost(getPath('stats/workgap/breakout/table'), payload);
    } catch (err) {
      await handleApiError(
        err,
        'getBreakoutTable',
        true,
        'Error fetching breakout table'
      );
    }
  },
};
